

















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class MypagePageLayout extends Vue {
  @Prop({ default: 1 }) index: any
  @Prop({ default: false }) isMyPage!: boolean
  @Prop({ default: '마이페이지' }) title!: boolean
  @Prop({ default: '' }) subTitle!: boolean

  get myPageSubTitle() {
    const name = this.$auth.user?.name
    return name ? `${name}님, 안녕하세요` : ''
  }

  get menu() {
    let route = this.$route.path.split('/')

    if (route.indexOf('myPage') > 0) {
      return [
        { title: '개인정보 변경', link: '/myPage' },
        { title: '예매내역', link: '/myPage/payment' },
        { title: '연간회원 내역', link: '/myPage/yearlyInfo' },
        { title: '문의내역', link: '/myPage/qna' },
        { title: '쿠폰함', link: '/myPage/coupon' },
      ]
    } else if (route.indexOf('recruit') > 0) {
      return [
        { title: '채용안내', link: '/home/recruit' },
        { title: '채용공고', link: '/home/recruit/notification' },
        {
          title: '아르바이트 지원하기',
          link: '/home/recruit/support',
          loginRequired: true,
        },
        {
          title: '지원결과',
          link: '/home/recruit/result',
          loginRequired: true,
        },
        { title: '채용FAQ', link: '/home/recruit/faq' },
      ]
    } else if (route.indexOf('enterprise') > 0) {
      return [
        { title: '기업소개', link: '/home/enterprise' },
        { title: 'BI&캐릭터', link: '/home/enterprise/bi' },
        { title: '공시정보', link: '/home/enterprise/disclosure' },
        { title: '재무정보', link: '/home/enterprise/financial' },
        { title: '윤리경영', link: '/home/enterprise/ethics' },
        { title: '기업PR', link: '/home/enterprise/pr' },
      ]
    } else if (route.indexOf('yearlyMembership') > 0) {
      return [
        { title: '가입방법', link: '/home/yearlyMembership' },
        { title: '회원권 종류', link: '/home/yearlyMembership/type' },
        { title: '할인혜택', link: '/home/yearlyMembership/discount' },
        { title: '특별/제휴 혜택', link: '/home/yearlyMembership/special' },
        { title: '멤버십 뉴스', link: '/home/yearlyMembership/news' },
        { title: 'FAQ', link: '/home/yearlyMembership/faq' },
      ]
    }
  }
}
